import { Component, Inject, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common/common.service';
import { EditBreakTimeComponent } from '../../recruitment/time-clock-card/edit-break-time/edit-break-time.component';
import { TimeSheetDetailsComponent } from '../../recruitment/time-clock-card/time-sheet-details/time-sheet-details.component';
import { ConfirmationModalComponent } from '../../dialog-modal/confirmation-modal/confirmation-modal.component';
import { GlobalService } from 'src/app/services/global/global.service';
import { AppService } from 'src/app/services/app/app.service';
import { TimeClockService } from 'src/app/services/time-clock/time-clock.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { AddTimeForSpecificJobComponent } from '../../recruitment/time-clock-card/add-time-for-specific-job/add-time-for-specific-job.component';
import { EditStEtComponent } from '../../recruitment/time-clock-card/edit-st-et/edit-st-et.component';

@Component({
  selector: 'app-manage-clocking',
  templateUrl: './manage-clocking.component.html',
  styleUrls: ['./manage-clocking.component.scss']
})
export class ManageClockingComponent {

  @Input() employeeId!: string | number;
  public currentSemiTab: string = "clock_request";
  public dataSourceToday = new MatTableDataSource();
  public dataSourceNotclockedIn = new MatTableDataSource();
  public googleMapLink = 'https://www.google.com/maps?q=@';
  displayedColumnsC: string[] = ['name', 'category', 'date', 'address', 'shift-time', 'phone-number', 'action'];
  public paramsData: any;
  public ifnot: boolean = false;
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public filterArr: any[] = [
    { key_name: "First Name", key_val: "first_name", type: 'text' },
    { key_name: "Last Name", key_val: "last_name", type: 'text' },
    { key_name: "Email", key_val: "email", type: 'text' },
  ]
  public clockData = {
    today_fill: 0,
    week_fill: 0,
    month_fill: 0,
    year_fill: 0,
    tot_clockin_today: 0
  };
  public objData = {
    timesheet: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 0,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    },
    clock_request: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 0,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    },
    not_clocked_tab: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 0,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    },
  };
  displayedColumnsF: string[] = ['name', 'category', 'time', 'break_time', 'clock-in', 'clock-out', 'total-hours', 'overtime', 'status', 'overtime_status', 'accept-reject', 'overtime_accept_reject'];
  isPageIndialLoad:boolean = false;


  constructor(private commonService: CommonService, private dialog: MatDialog, private appService: AppService, private timeClockService: TimeClockService,
    private spinner: NgxSpinnerService, private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.isPageIndialLoad = true;
    setTimeout(() => {
      this.onSemiTabChange('clock_request');
    }, 100)
  }

  onSemiTabChange(value) {
    this.currentSemiTab = value;
    if (this.currentSemiTab == 'clock_request') {
      this.getTodayList();
    }
    else {
      this.getNotClockInList()
    }
  }

  callApi(obj, type) {
    this.objData[type].arr = obj.arr;
    this.objData[type].operand = obj.operand
    this.onTabAPICall(type)
  }

  onEditBreakTime(item) {
    const dataObj = {
      em_i: item.em_i,
      br_tii: item.br_tii,
      br_tio: item.br_tio,
      clock_id:item.clock_id,
      st_ti:item.st_ti,
      ed_ti:item.ed_ti,
      j_id:item.id,
      date:item.date,
      type: "break"
    }
    const dialogRef = this.dialog.open(EditBreakTimeComponent, {
      minWidth: "300px",
      data: dataObj,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
      this.getTodayList();
    });
  }
  onSearch(event: any,type:string) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.objData[type].previousInputValue !== '') {
      this.objData[type].currentPage = 1
      if (type=='clock_request') {        
        this.getTodayList()
      }
      if (type=='not_clocked_tab') {        
        this.getNotClockInList()        
      }
    }
  }
  onGo(type:string) {
    if (this.objData[type].sh.trim() != '') {
      this.objData[type].currentPage = 1
      if (type=='clock_request') {        
        this.getTodayList()
      }      
      if (type=='not_clocked_tab') {        
        this.getNotClockInList()        
      }
    }
  }

  openTimeSheetDetailsModel(item) {
    let objData = item;
    item["params"] = this.paramsData;
    const dialogRef = this.dialog.open(TimeSheetDetailsComponent, {
      enterAnimationDuration: '300ms',
      exitAnimationDuration: "300ms",
      minWidth: '300px',
      width: '90%',
      height: '90%',
      maxWidth: '100%',
      data: objData
      // maxHeight: '800px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) { }
    });
  }

  confirmationAlert(dataObj: any, type: string, value: string) {
    let data = {
      "j_id": dataObj.id,
      "clock_id": dataObj.clock_id,
      "em_i": dataObj.em_i,
      "app": "",
      ov_ti_app: ""
    }
    if (type == "overtime") {
      data["ov_ti_app"] = value;
    }
    else {
      data["app"] = value;
    }
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: { content_type: 'accept_reject', dataObj: data, item_type: "time_clock_status",data_type: "change" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.confirm_yes == true) {
        this.getTodayList()
      }
    });
  }

  getTodayList() {
    let obj = {
      em_i: this.employeeId,
      // em_i: 118,
      f_a: this.objData.clock_request.arr,
      op_nd: this.objData.clock_request.operand,
      sh: this.objData.clock_request.sh,
      st: this.appService.startPageLogic(this.objData.clock_request.currentPage, this.objData.clock_request.itemsPerPage),
      r_p: this.objData.clock_request.itemsPerPage,
    }
    this.dataSourceToday = new MatTableDataSource();
    this.spinner.show();
    this.timeClockService.manageTimeClock(obj).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        //   this.isSpinnerLoading = false
        if (success.status == 200) {
          this.objData.clock_request.previousInputValue = this.objData.clock_request.sh;
          this.objData.clock_request.count = success.count;
          this.dataSourceToday = new MatTableDataSource(success.msg)
        }
      },
      error: (error: any) => {
        //   this.isSpinnerLoading = false
        this.dataSourceToday.data = [];
        this.objData.clock_request.previousInputValue = this.objData.clock_request.sh;
        this.commonService.handleError(error);
      }
    })
  }


  onPageSizeChange(event: Event, type: string) {
    const tar = event.target as HTMLInputElement
    this.objData[type].itemsPerPage = Number(tar.value)
    this.objData[type].currentPage = 1
    this.onTabAPICall(type)
  }
  onPageChange(number: number, type: string) {
    if(this.isPageIndialLoad){
      this.isPageIndialLoad=false;
      return;
    }
    this.objData[type].currentPage = number;
    this.onTabAPICall(type);
  }
  onTabAPICall(type) {
    if (type == 'clock_request') {
      this.getTodayList();
    } else if (type == 'not_clocked_tab') {
      this.getNotClockInList()
    }
    else {
    }
  }

  getNotClockInList() {
    let obj = {
      em_i: this.employeeId,
      f_a: this.objData.not_clocked_tab.arr,
      op_nd: this.objData.not_clocked_tab.operand,
      sh: this.objData.not_clocked_tab.sh,
      st: this.appService.startPageLogic(this.objData.not_clocked_tab.currentPage, this.objData.not_clocked_tab.itemsPerPage),
      r_p: this.objData.not_clocked_tab.itemsPerPage,
    }
    this.dataSourceNotclockedIn = new MatTableDataSource();
    this.objData.not_clocked_tab.previousInputValue = this.objData.not_clocked_tab.sh;
    this.spinner.show();
    this.timeClockService.notclockInDate(obj).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        //   this.isSpinnerLoading = false
        if (success.status == 200) {
          this.dataSourceNotclockedIn = new MatTableDataSource(success.msg);
          this.objData.not_clocked_tab.count = success.count;
        }
      },
      error: (error: any) => {
        this.dataSourceNotclockedIn.data = [];
        this.objData.not_clocked_tab.previousInputValue = this.objData.not_clocked_tab.sh;
        //   this.isSpinnerLoading = false
        this.commonService.handleError(error);
      }
    })
  }


  onAddTimeForSpecificJob(element: any) {
    const dialogRef = this.dialog.open(AddTimeForSpecificJobComponent, {
      minWidth: "300px",
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      width: '55%',
      maxWidth: '90vw',
      autoFocus: false,
      data: element,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }

  onEditClockTime(item) {
      if (item.ed_ti == "00:00:00") {
        this.appService.showToastMessage('error', "You cannot edit the time because you have not clocked out yet.");
        return;
      }
      const dataObj = {
        em_i: item.em_i,
        clock_id: item.clock_id,
        j_id: item.id,
        date: item.date,
        br_tii: item.br_tii,
        br_tio: item.br_tio,
        st_ti: item.st_ti,
        ed_ti: item.ed_ti,
        type: "edit-clock-time",
      };
      const dialogRef = this.dialog.open(EditStEtComponent, {
        minWidth: "300px",
        data: dataObj,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
        }
        this.getTodayList();
      });
    }
}
